import { MAX_TODO_REPORT_MB } from '../constants';

export const HTML_REPORT_ACCEPT = '.html,.htm,text/html';

export const isHtmlReportFile = (file: Pick<File, 'type' | 'name'>): boolean => {
    const name = file.name || '';
    if (/\.html?$/i.test(name)) {
        return true;
    }
    const mime = (file.type || '').toLowerCase();
    return mime === 'text/html' || mime === 'application/xhtml+xml';
};

export const validateHtmlReportFile = (file: File): string | null => {
    if (!isHtmlReportFile(file)) {
        return 'Можно загружать только HTML-отчёт (.html, .htm)';
    }
    if (file.size > MAX_TODO_REPORT_MB * 1024 * 1024) {
        return `Размер HTML-отчёта не должен превышать ${MAX_TODO_REPORT_MB}MB`;
    }
    return null;
};
